const state = {
    namespaced: true,
    state() {
        return {
            mainSlides: [],
            headerSlides: [],
            slidesIsLoaded: false,
        };
    },
    getters: {
        getMainSlides: state => state.mainSlides,
        getHeaderSlides: state => state.headerSlides,
        getSlidesIsLoaded: state => state.slidesIsLoaded,
    },
    mutations: {
        SET_MAIN_SLIDES: (state, slides) => (state.mainSlides = slides),
        SET_HEADER_SLIDES: (state, slides) => (state.headerSlides = slides),
        SET_SLIDES_IS_LOADED: (state, value) => (state.slidesIsLoaded = value),
    },
    actions: {
        async fetchSlidesBanners({ commit }) {
            commit('SET_SLIDES_IS_LOADED', false);
            try {
                const data = await this.$axios.$get('base/slides_banner');
                const main = data?.filter(item => item?.show_on === 'main' || item?.show_on === null);
                const header = data?.filter(item => item?.show_on === 'top');
                commit('SET_MAIN_SLIDES', main);
                commit('SET_HEADER_SLIDES', header);
            } catch (e) {
                console.error(e);
            } finally {
                commit('SET_SLIDES_IS_LOADED', true);
            }
        },
    },
};

export default state;
